import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tencent_hunyuan'

/**
 * Inverse of parseTencentMeshSimplificationProData. Builds an openedModel-shaped
 * payload from the current remeshSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTencentMeshSimplificationProData
 */
export const buildTencentMeshSimplificationProFromState = (state, id) => {
  const { remeshSettings } = state
  const {
    faceLevel,
    polygonType,
  } = remeshSettings || {}

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TENCENT_MESH_SIMPLIFICATION_PRO,
    providerRunAttributes: {
      ...(faceLevel != null && { faceLevel }),
      ...(polygonType != null && { polygonType }),
    },
  }
}
